import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import OkCancelModal from '@/shared/components/OkCancelModal';
import messages from '../messages';
import AssignmentTemplateSelector from '@/shared/components/input/AssignmentTemplateSelector';

class ChangePlannedRegistrationAssignmentModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      assignmentTemplateId: null,
    };
  }
  state = {};

  isFormInvalid = () => {
    const { assignmentTemplateId } = this.state;
    if (!assignmentTemplateId) return true;
    return false;
  };
  showValidation = () => this.setState({ showValidation: true });

  assignmentChanged = id => {
    this.setState({ assignmentTemplateId: id });
  };

  onSave = () => {
    if (this.isFormInvalid()) return;
    const { onSave } = this.props;
    const { assignmentTemplateId } = this.state;
    return onSave({ assignmentTemplateId });
  };

  render() {
    const { show, onClose, intl } = this.props;
    const { assignmentTemplateId, showValidation } = this.state;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.ChangeAssignment)}
        show={show}
        onClose={onClose}
        disabled={showValidation && this.isFormInvalid()}
        onHoverSave={this.showValidation}
        onSave={this.onSave}
      >
        <div className="form-horizontal">
          <div className="form-group">
            <label className="col-sm-4 control-label" htmlFor="user">
              <FormattedMessage {...messages.AssignmentTemplate} />
            </label>
            <div className="col-sm-7">
              <AssignmentTemplateSelector
                value={assignmentTemplateId}
                onChange={id => this.assignmentChanged(id || null)}
                showDefaultAssignment
              />
            </div>
          </div>
        </div>
      </OkCancelModal>
    );
  }
}

ChangePlannedRegistrationAssignmentModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,

  intl: intlShape.isRequired,
};
ChangePlannedRegistrationAssignmentModal.defaultProps = {
  show: false,
};
export default ChangePlannedRegistrationAssignmentModal;
